/* eslint-disable prettier/prettier */
/* eslint-disable */

import { connectReducers } from '../../utils';

import { FAILURE, INVALIDATE, REQUEST, SUCCESS } from '../../actions/utils';

import genericReducers from '../genericReducer';
import { IReducers } from '..';
import { ICommonResponse, IStudentReward } from '../../api/types';
import { GET_STUDENT_REWARDS } from '../../actions';

export type StudentRewardsState = ICommonResponse<IStudentReward>;

const initialState: StudentRewardsState = {
  content: [],
  loading: false,
};
const generic = genericReducers<StudentRewardsState>();
const studentRewards: IReducers<StudentRewardsState> = {
  [GET_STUDENT_REWARDS[REQUEST]]: generic.get.request,
  [GET_STUDENT_REWARDS[SUCCESS]]: generic.get.success,
  [GET_STUDENT_REWARDS[FAILURE]]: generic.get.failure,
  [GET_STUDENT_REWARDS[INVALIDATE]]: generic.get.invalidate(initialState),
};

export default connectReducers(initialState, studentRewards);
